import React, { useState } from "react";
import { Images } from "../Components/Images";
import { Modal } from "react-bootstrap";
import Web3 from "web3";
import toast, { Toaster } from "react-hot-toast";
import { MetamaskWallet, WalletConnect } from "../Hooks/useWallet";
import { getAccount } from "../Hooks/useAccount";
import { addNewUser } from "../actions/user";
import { useDispatch } from "react-redux";
import { setWalletAddress } from "../lib/localStorage";
import { useParams } from "react-router-dom";


const ConnectWallet = ({ show, handleClose }) => {

  const [accounts, setAccounts] = useState([]);
  const [wallet, setWallet] = useState("");
  let { code } = useParams()
  const dispatch = useDispatch();
  const addUser = async (wallet) => {
    try {
      console.log(code, "CODE")
      let referrerCode = code
      let { status, message, result, data } = await addNewUser({ walletAddress: wallet, referrerCode: referrerCode }, dispatch);
      if (status == true) {
        toast.success(message)
        setWalletAddress(wallet)
      }
      else {
        toast.error(message)
      }

    } catch (err) {
      console.log(err, "ERRRRRRRR")
    }
  };


  const connectWallet = async () => {
    MetamaskWallet()
      .then(async (data) => {
        console.log("🚀 ~ .then ~ data:", data)
        await addUser(getAccount());
        setWallet(getAccount());
        handleClose();
      })
      .catch((e) => {
        console.log(e);
      });
  };
  // Wallet Connect
  const enableWallet = async () => {
    try {
      setTimeout(() => handleClose(), 700);
      const provider = await WalletConnect();
      await addUser(getAccount());
      setWallet(getAccount());
      handleClose();
    } catch (e) {
      console.log("Error : ", e);
    }
  };
  return (
    <>
      <Modal
        centered
        size="sm"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="connectModal">
        <Modal.Body className="cmn__modal p-3">
          <p className="text-end m-0 modal__closer" onClick={handleClose}>
            <i class="fa-solid fa-xmark" />
          </p>
          <h5 class="title_txt mb-0 text-white">Select Wallet:</h5>
          <div className="d-flex justify-content-between mt-4 pt-1 gap-4">
            <div
              className="cnctWallet__singleBox d-flex flex-column justify-content-center align-items-center"
              onClick={connectWallet}>
              <img
                src={Images.metamask}
                className="img-fluid opCard__coinImg"
                alt=""
              />
              <p className="m-0 hebrew_font ticketManage__question mt-2 text-center">
                Metamask
              </p>
            </div>
            <div
              className="cnctWallet__singleBox d-flex flex-column justify-content-center align-items-center"
              onClick={connectWallet}>
              <img
                src={Images.trustWallet}
                className="img-fluid opCard__coinImg"
                alt=""
              />
              <p className="m-0 hebrew_font ticketManage__question mt-2 text-center">
                {" "}
                Trust Wallet
              </p>
            </div>
            <div
              className="cnctWallet__singleBox d-flex flex-column justify-content-center align-items-center"
              onClick={enableWallet}>
              <img
                src={Images.walletConnect}
                className="img-fluid opCard__coinImg"
                alt=""
              />
              <p className="m-0 hebrew_font ticketManage__question mt-2 text-center">
                Wallet Connect
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConnectWallet;
